import { CandidateResumeProposedVacanciesPage } from '@pages/candidate';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta(
    'Предложенные вакансии',
    'Вакансии, предложенные по резюме кандидата'
  );
}

export default CandidateResumeProposedVacanciesPage;
